export default "__VITE_ASSET__C6r$oyjd__"